import { Box, Button, Flexbox, Heading, Modal, ModalBody, ModalFooter, ModalHeader, Select, Stack, StackRow } from "codekit";
import React, { useMemo } from "react";
import { useUserAbsentMutation, useGetTiposAusenciasQuery } from "../../libs/redux/slices/authSlice/authApiSlice";
import { Controller, useForm } from "react-hook-form";

const Userause = ({ infoUser, setOpenModalAusent, setIsAusent }) => {
  const [userAbsent, { isLoading }] = useUserAbsentMutation();
  const { data: tiposAusencias, isLoading: loadingTiposAusencias } = useGetTiposAusenciasQuery();
  const { USRIDXXX, USREMAXX } = infoUser;

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      TIPAUSID: '',
    }
  });

  const watchedValue = watch('TIPAUSID');

  const onSubmit = async (data) => {
    try {
      console.log("Submitting data:", data);
      const ausencias = Array.isArray(tiposAusencias) ? tiposAusencias : (tiposAusencias?.data || []);
      const selectedAusencia = ausencias.find(e => e.TIPAUSID === data.TIPAUSID);

      await userAbsent({
        "USRIDXXX": USRIDXXX,
        "USREMAXX": USREMAXX,
        "JUSTIFIC": data.TIPAUSID,
        "TIPAUSDE": selectedAusencia?.TIPAUSDE || ''
      }).unwrap();
      setIsAusent((prev) => !prev);
      setOpenModalAusent(false);
    } catch (error) {
      console.error("Error al reportar ausencia:", error);
    }
  };

  const AusenciasOptions = useMemo(
    () => {
      const ausencias = Array.isArray(tiposAusencias) ? tiposAusencias : (tiposAusencias?.data || []);
      return ausencias.map((e) => ({ value: e.TIPAUSID, text: e.TIPAUSDE }));
    },
    [tiposAusencias]
  );

  return (
    <>
      <Modal isOpen={true}>
        <ModalHeader>
          <Flexbox justifyContent="between" alignItems="center">
            <Heading variant="heading-5">Justificacion Ausentismo</Heading>
            <Button variant="secondary" onlyIcon icon='close' size="m" onClick={() => setOpenModalAusent(false)}>
            </Button>
          </Flexbox>
        </ModalHeader>
        <ModalBody size="sm">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box mb={8} bg="neutral-200" border={1} borderColor="neutral-300" spacing={3} rounded="md">
              <Box spacing={5} border={1} rounded='md' borderColor='neutral-300' bg='white'>
                <Stack gap={4}>
                  <StackRow>
                    <Controller
                      control={control}
                      name="TIPAUSID"
                      rules={{ required: "Debe seleccionar un tipo de ausencia" }}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          options={AusenciasOptions}
                          isLoading={loadingTiposAusencias}
                          value={value}
                          onChangeValue={(context) => onChange(context.option.value)}
                          placeholder="Seleccione tipo de ausencia"
                        />
                      )}
                    />
                    {errors.TIPAUSID && (
                      <Box mt={2}>
                        <span style={{ color: 'red', fontSize: '0.875rem' }}>
                          {errors.TIPAUSID.message}
                        </span>
                      </Box>
                    )}
                  </StackRow>
                </Stack>
              </Box>
            </Box>
          </form>
        </ModalBody>
        <ModalFooter>
          <Flexbox justifyContent="between" alignItems="center" gap={4}>
            <Button type="button" variant="secondary" size="2l" minWidth={200} onClick={() => setOpenModalAusent(false)}>
              Cancelar
            </Button>
            <Button
              type="button"
              variant="primary-bold"
              size="2l"
              minWidth={200}
              onClick={handleSubmit(onSubmit)}
              disabled={!watchedValue}
              isLoading={isLoading}
            >
              Guardar
            </Button>
          </Flexbox>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Userause;
